<template>
  <div class="text-xs-center">
    <v-menu
      max-width="800"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      lazy
    >
      <template v-slot:activator="{ on }">
        <v-btn flat icon v-on="on">
          <img style="width:25px; height:25px;" src="@/assets/images/settings.png" />
        </v-btn>
      </template>

      <v-card>
        <v-layout wrap row pa-3>
          <!-- <v-flex xs12 md4 px-2>
            <v-select
              v-model="localFilters.type"
              :items="matchTypes"
              :readonly="tournamentView"
              :clearable="!tournamentView"
              @change="onChangeType"
              :label="$t('fields.global.type')"
            ></v-select>
          </v-flex>-->
          <!-- <v-flex xs12 md8 px-2 v-if="localFilters.type !== 'tournament'">
            <category-menu
              v-model="localFilters.categoryId"
              clearable
              :label="$tc('models.category')"
            ></category-menu>
          </v-flex>-->
          <!-- <v-flex v-else-if="localFilters.type === 'tournament'" xs12 md8 px-2>
            <tournament-field
              v-model="localFilters.tournamentId"
              :label="$tc('models.tournament')"
              :readonly="tournamentView"
              :clearable="!tournamentView"
            ></tournament-field>
          </v-flex>-->
          <!-- <v-flex xs12>
            <v-layout wrap row>
              <v-flex xs12 md8 px-2>
                <entity-field
                  v-model="localFilters.entityId"
                  :tournamentId="localFilters.tournamentId"
                  :isCustomer="localFilters.isCustomer"
                  :label="$tc('models.entity')"
                ></entity-field>
              </v-flex>
            </v-layout>
          </v-flex>-->
          <!-- <v-flex xs12>
            <v-layout wrap row>
              <v-flex xs12 px-2>
                <team-field
                  v-model="localFilters.homeTeamId"
                  :entityId="localFilters.entityId"
                  :categoryId="localFilters.categoryId"
                  :tournamentId="localFilters.tournamentId"
                  :isCustomer="localFilters.isCustomer"
                  :label="$t('fields.matches.homeTeam')"
                  :all="isOwnTeam('visitorTeam',localFilters.visitorTeamId)"
                  ref="homeTeam"
                ></team-field>
              </v-flex>
              <v-flex xs12 px-2>
                <team-field
                  v-model="localFilters.visitorTeamId"
                  :entityId="localFilters.entityId"
                  :tournamentId="localFilters.tournamentId"
                  :categoryId="localFilters.type === 'league' ? localFilters.categoryId : ''"
                  :isCustomer="localFilters.isCustomer"
                  :label="$t('fields.matches.visitorTeam')"
                  :all="isOwnTeam('homeTeam',localFilters.homeTeamId)"
                  ref="visitorTeam"
                ></team-field>
              </v-flex>
              <v-flex xs12 md6 px-3>
                <pitch-field
                  v-model="localFilters.location"
                  :tournamentId="localFilters.tournamentId"
                  :entityId="localFilters.entityId"
                  :teamId="localFilters.homeTeamId"
                  :label="$t('fields.global.location')"
                ></pitch-field>
              </v-flex>
            </v-layout>
          </v-flex>-->

          <!-- Filtro fechas -->
          <v-flex xs12>
            <v-layout wrap row>
              <v-flex xs12 md6 px-2>
                <date-picker v-model="localFilters.dateStart" :label="$t('startAt')"></date-picker>
              </v-flex>

              <v-flex xs12 md6 px-2>
                <date-picker v-model="localFilters.dateEnd" :label="$t('endAt')"></date-picker>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 px-2>
            <v-radio-group v-model="localFilters.finalized" row>
              <v-radio :label="$t('all')" color="primary" value="all"></v-radio>
              <v-radio :label="$t('finalized')" color="primary" :value="true"></v-radio>
              <v-radio :label="$t('notFinalized')" color="primary" :value="false"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            flat
            @click="search"
            :loading="$store.state.matches.loading"
          >{{ $t('search') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

// import CategoryMenu from '@/components/management/categories/CategoryMenu'
// import TournamentField from '@/components/widgets/Input/TournamentField'
// import EntityField from '@/components/widgets/Input/EntityField'
// import TeamField from '@/components/widgets/Input/TeamField'
// import PitchField from '@/components/widgets/Input/PitchField'
import DatePicker from '@/components/widgets/Input/DatePicker'

export default {
  name: 'MatchFilters',
  components: {
    // CategoryMenu,
    // TeamField,
    // EntityField,
    // TournamentField,
    // PitchField,
    DatePicker
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({})
    },
    tournamentView: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    menu: false
  }),
  watch: {
    tournamentId(val) {
      if (val && this.tournamentView) {
        this.localFilters.tournamentId = val
        this.localFilters.type = 'tournament'
      }
    }
  },
  computed: {
    ...mapState({
      tournamentId: state => state.tournaments.idSelected
    }),
    // ...mapGetters({
    //   matchTypes: 'matches/matchTypes'
    // }),
    localFilters: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    search() {
      this.menu = false
      this.$emit('search')
    }
    // onChangeType(val) {
    //   if (val === 'tournament') this.localFilters.categoryId = ''
    //   else this.localFilters.tournamentId = ''
    // },

    // isOwnTeam(type, teamId) {
    //   if (
    //     this.isAdmin ||
    //     (this.localFilters.tournamentId &&
    //       this.is('coordinatorTournament', this.localFilters.tournamentId))
    //   )
    //     return true

    //   let hasRole = teamId && this.is('trainer', teamId)
    //   if (!hasRole && this.$refs[type]) {
    //     hasRole = this.$refs[type].itemList.some(
    //       item =>
    //         item.value === teamId &&
    //         this.is(['president', 'coordinator'], item.entityId)
    //     )
    //   }
    //   return hasRole
    // }
  }
}
</script>
